import PressureTestsAnnotationAction from './pressure-tests-annotation-action'
import ServiceLocator from 'live/services/service-locator'

try {
    require('./init')
    const Form = require('./form')
    const View = require('./view')
    const ExtensionService = require('live/services/extension')

    const i18n = require('live/services/i18n')

    const sisp = {
        name: i18n('SIP'),
        type: 'liverig-sisp',
        origin: 'Plugin Petrobras',
        roles: [],
        icon: '/content/plugin-petrobras/sisp.png',
        ui: {
            form: Form,
            view: View
        }
    }

    ServiceLocator.getService('pressure-test-annotation-action-registry').then(service =>
        service.register(PressureTestsAnnotationAction)
    )

    ExtensionService.register(sisp)
} catch (e) {
    console.error(e)
}
